import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';

export const {
	Context: LocalPagePaginatedRecentPetitionsDataContext,
	Provider: LocalPagePaginatedRecentPetitionsDataContextProvider,
	useContext: useLocalPagePaginatedRecentPetitionsData,
	useAsyncData: useLocalPagePaginatedRecentPetitionsDataFromApi,
	prefetchAsyncData: prefetchLocalPagePaginatedRecentPetitionsDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'LocalPagePaginatedRecentPetitionsDataContext',
	dataProperty: 'recentPetitionsPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug, { listTagsFilter }) => [slug, listTagsFilter].join('|'),
	hookDeps: (slug, { listTagsFilter }) => [slug, listTagsFilter],
	errorHandler: pageDataErrorHandler(),
});
